import React from 'react';
import { Box, Fade } from '@mui/material';
import HamburgerMenuIcon from './HamburgerMenuIcon';
import HamburgerNavMenu from './Account/HamburgerNavMenu';
import { useIsAuthenticated } from '@azure/msal-react';

export type HamburgerMenuProps = {
    closeMenu?: () => void;
};

const HamburgerMenu = () => {
    const isAuthenticated = useIsAuthenticated();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const menuRef = React.useRef<HTMLElement>();
    const iconRef = React.useRef<HTMLElement>();

    const onHamburgerClose = () => {
        setIsOpen(false);
    };

    const onHamburgerToggle = () => {
        setIsOpen((prev) => !prev);
    };

    React.useEffect(() => {
        !isAuthenticated && setIsOpen(false);
    }, [isAuthenticated]);

    React.useEffect(() => {
        const closeDropdownFromOutside = (ev: MouseEvent) => {
            const outsideOfMenu = menuRef.current && !menuRef.current.contains(ev.target as Node);
            const hamburgerMenu = iconRef.current && iconRef.current.contains(ev.target as Node);

            if (outsideOfMenu && !hamburgerMenu) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', closeDropdownFromOutside);

        return () => {
            document.removeEventListener('mousedown', closeDropdownFromOutside);
        };
    }, [menuRef, iconRef]);

    return (
        <Box>
            <Box ref={iconRef}>
                <HamburgerMenuIcon sx={{}} onClick={onHamburgerToggle} />
            </Box>
            <Fade in={isOpen}>
                <Box
                    sx={{
                        width: '100%',
                        position: 'absolute',
                        left: 0,
                        zIndex: 10
                    }}>
                    <Box
                        ref={menuRef}
                        sx={{
                            margin: '1.563rem',
                            marginTop: '0.625rem',
                            padding: 2,
                            borderRadius: 2,
                            boxShadow: '0 0.25rem 0.625rem 0 #0000004D',
                            backgroundColor: (t) => t.palette.secondary.main
                        }}>
                        <HamburgerNavMenu closeMenu={onHamburgerClose} />
                    </Box>
                </Box>
            </Fade>
        </Box>
    );
};

export default HamburgerMenu;
